import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AppLoader from 'Src/components/AppLoader';
import { useLogger } from 'Src/feature/context-logger/useLogger';
import { TextModal } from 'Src/feature/modal/TextModal';
import { useCurrentOperator } from 'Src/feature/operator/useCurrentOperator';
import { useOperator } from 'Src/feature/operator/useOperator';
import { useToast } from 'Src/feature/toasts/useToast';
import useRoute from 'Src/routes/useRoute';

const sectionId = 'POSBeginBreak';

/**
 * POSBeginBreak
 * @description - route component used to begin the user's break time
*/
const POSBeginBreak: FC = () => {
  const { t } = useTranslation();
  const log = useLogger().getSubLogger({ name: sectionId });
  const toast = useToast();
  const { crumbs, navigate } = useRoute();
  const { setCurrentOperator } = useCurrentOperator();
  const operatorBeginBreak = useOperator.mutate.beginBreak();
  const operatorLogout = useOperator.mutate.logout();

  const isUnapprovedBreak = false;

  const beginBreak = async (breakRuleId: number | undefined) => {
    try {
      await operatorBeginBreak.mutateAsync({ breakRuleId });
      await operatorLogout.mutateAsync();
      const timeout = isUnapprovedBreak ? 5000 : 0;
      setTimeout(() => {
        setCurrentOperator(undefined);
        navigate(crumbs.pos.main.path);
      }, timeout);
    } catch (err) {
      navigate(-1);
      log.error('beginBreak', err);
      toast.show.serviceError(err, { title: t('break.labels.beginBreak') });
    }
  };

  useEffect(() => {
    void beginBreak(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <AppLoader />
      <TextModal
        color="error"
        title={t('break.labels.nonApprovedBreak.title')}
        open={isUnapprovedBreak}
        textContent={t('break.labels.nonApprovedBreak.body')}
      />
    </>
  );
};

export default POSBeginBreak;
